// One local-calendar-date helper, shared by the calendar grid and the capture
// form. It lives here rather than inside either of them because the two had
// diverged: the calendar had this, the capture form called toISOString() and
// pre-filled tomorrow for anyone filling it in after ~5pm Pacific — which is
// exactly when a capture gets filled in.

// "YYYY-MM-DD" in the browser's local calendar date — NOT toISOString(), which
// converts to UTC and shifts the date by a day in negative-UTC-offset timezones.
export function localISODate(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

// Today, read at call time. Never hoist this into a module-level constant: a
// cockpit tab left open across midnight would then pre-fill yesterday.
export function todayISO() {
  return localISODate(new Date());
}
